import { fill, messages, type Lang } from "../i18n/index";

type FatalKey = "skeleton" | "webgl" | "startup" | "renderLoop";

/** Replaces the page with a localised error; `error` fills the `{error}` placeholder. */
export function showFatal(lang: Lang, key: FatalKey, error?: unknown): void {
  const detail = error instanceof Error ? error.message : String(error);
  document.body.innerHTML = "";
  const box = document.createElement("pre");
  box.className = "fatal";
  box.textContent = fill(messages(lang).fatal[key], { error: detail });
  document.body.append(box);
}
